import emptyApi from '@epi-api/emptyApi';
import config from '@epi-config';
import { get } from '@epi-helpers/FetchHelpers';
import { CardOrdersResponse } from '@epi-models/pages/Reports';
import { TRANSACTIONS_PAGE_SIZE } from '@epi-api/constants';

export const getOrdersRequest = async (
  page: number,
  cardType: string,
  from: string,
  to: string,
  abortController: AbortController | null = null
): Promise<{ data?: CardOrdersResponse; error?: any }> => {
  try {
    const response: CardOrdersResponse | undefined = await get(
      `${config.apiHost}/api/user-transactions/card-order-history/${page}/${cardType}?pageSize=${TRANSACTIONS_PAGE_SIZE}&filterStartDate=${from}&filterEndDate=${to}`,
      undefined,
      undefined,
      abortController?.signal
    );
    return { data: response };
  } catch (e) {
    return { error: e };
  }
};

export const loadOrdersApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    getOrders: build.query<
      CardOrdersResponse,
      {
        page: number;
        cardType: string;
        from: string;
        to: string;
        pageSize?: number;
        abortController: AbortController | null;
      }
    >({
      queryFn: ({ page, cardType, from, to, abortController }) =>
        getOrdersRequest(page, cardType, from, to, abortController),
      keepUnusedDataFor: 0
    })
  })
});

export const { useGetOrdersQuery, useLazyGetOrdersQuery } = loadOrdersApi;
